import React from "react";
import PublicProposal from "./PublicProposal";
import { PREVIEW_KEY } from "../components/PreviewModal";

export default function PreviewFrame() {
  let data = null;
  try { data = JSON.parse(localStorage.getItem(PREVIEW_KEY) || "null"); } catch (e) { data = null; }
  if (!data) return <p className="p-10 text-center text-slate-500">Anteprima non disponibile. Riaprila dall'editor.</p>;
  return <PublicProposal previewData={data} />;
}
